import { Package } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Neutral fallback tile shown in place of a product photo when an item has no
 * `image_url`. Replaces the old saturated orange→pink gradient that turned a
 * photo-less menu grid into a wall of warm color — a soft `bg-muted` tile with
 * a faint icon instead, so the names and prices lead.
 *
 * Single source of truth for the placeholder, shared by the checkout counter
 * grid and the admin menu views so they can never drift apart again.
 *
 * `className` sets the tile size + rounding and `iconClassName` the icon size;
 * both are merged last via `cn` (tailwind-merge), so each call site keeps its
 * exact geometry while sharing the neutral look.
 */
export function ProductImagePlaceholder({
  className,
  iconClassName,
}: {
  className?: string
  iconClassName?: string
}) {
  return (
    <div className={cn('flex items-center justify-center rounded-md bg-muted', className)}>
      <Package className={cn('h-6 w-6 text-muted-foreground/40', iconClassName)} aria-hidden />
    </div>
  )
}
